import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@repo/ui";
import { Alert, AlertDescription } from "@repo/ui";
import { StardeckSignInButton, useAuth } from "@stardeck-customer-apps/project-auth";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Login() {
  const { user, isLoading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");

  const returnTo = searchParams.get("returnTo") || "/admin";
  const errorParam = searchParams.get("error");

  useEffect(() => {
    document.title = "Login | House & Condo Expo";
  }, []);

  useEffect(() => {
    if (user && !authLoading) {
      navigate(returnTo, { replace: true });
    }
  }, [user, authLoading, navigate, returnTo]);

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (user) {
    return null;
  }

  const errorMessage = errorParam || error;

  return (
    <div className="flex items-center justify-center bg-background px-4 py-12">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold tracking-tight">House & Condo Expo</h1>
        </div>

        <Card>
          <CardHeader className="text-center">
            <CardTitle>Sign in to the House & Condo Expo</CardTitle>
            <CardDescription>Use your Stardeck account to continue</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            {errorMessage && (
              <Alert variant="destructive">
                <AlertDescription>{errorMessage}</AlertDescription>
              </Alert>
            )}

            <StardeckSignInButton
              style={{ width: "100%" }}
              onSuccess={() => navigate(returnTo, { replace: true })}
              onError={(err) => setError(err.message)}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
